import React from 'react';
import { motion } from 'framer-motion';
export function Process() {
  const steps = [{
    title: 'Erstgespräch',
    desc: 'Kennenlernen, Zielsetzung und Klärung der Rahmenbedingungen.'
  }, {
    title: 'Gebäudeanalyse',
    desc: 'Detaillierte Bestandsaufnahme vor Ort und Datenauswertung.'
  }, {
    title: 'Beratung & Konzept',
    desc: 'Entwicklung passgenauer Sanierungsvarianten und Wirtschaftlichkeitsbetrachtung.'
  }, {
    title: 'Fördermittelstrategie',
    desc: 'Auswahl der optimalen Förderprogramme (BAFA/KfW).'
  }, {
    title: 'Umsetzung & Begleitung',
    desc: 'Fachplanung und Qualitätssicherung während der Bauphase.'
  }];
  return <section id="prozess" className="py-24 md:py-32 bg-secondary" data-id="element-301">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-302">
        <div className="mb-20" data-id="element-303">
          <h2 className="text-4xl md:text-5xl font-serif text-accent mb-6" data-id="element-304">
            So läuft die Zusammenarbeit ab
          </h2>
          <p className="text-lg text-accent/70 font-light max-w-2xl" data-id="element-305">
            Ein strukturierter Prozess garantiert, dass wir Ihre Ziele effizient
            und transparent erreichen.
          </p>
        </div>

        <div className="relative" data-id="element-306">
          {/* Vertical line for desktop */}
          <div className="hidden md:block absolute left-[28px] top-4 bottom-4 w-px bg-accent/20" data-id="element-307"></div>

          <div className="space-y-12 md:space-y-16" data-id="element-308">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.6,
            delay: index * 0.1
          }} className="relative flex flex-col md:flex-row gap-6 md:gap-12" data-id="element-309">
                <div className="flex items-center md:items-start gap-6 md:gap-0" data-id="element-310">
                  <div className="w-14 h-14 rounded-full bg-white border border-accent/10 flex items-center justify-center text-xl font-serif text-primary shadow-sm z-10 shrink-0" data-id="element-311">
                    0{index + 1}
                  </div>
                  {/* Mobile line connector */}
                  {index < steps.length - 1 && <div className="md:hidden absolute left-7 top-14 bottom-[-3rem] w-px bg-accent/20" data-id="element-312"></div>}
                </div>

                <div className="md:pt-3" data-id="element-313">
                  <h3 className="text-2xl font-serif text-accent mb-3" data-id="element-314">
                    {step.title}
                  </h3>
                  <p className="text-accent/70 font-light text-lg" data-id="element-315">
                    {step.desc}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}